import { EKwikUIInputCurrencySize } from "./input-currency.definitions";

export const DEFAULT_VALUES = {
  currencyType: null,
  disabled: false,
  focus: false,
  formControlName: "form_control_input_currency",
  hintContent: "",
  icon: "",
  id: "input",
  invalid: false,
  label: "Input",
  placeholder: "Please enter input currency",
  postfix: "",
  prefix: "",
  size: EKwikUIInputCurrencySize.L,
  value: ""
};

export const VALIDATE_KEY_VALUES = {
  currencyType: true,
  disabled: true,
  focus: true,
  formControlName: true,
  hintContent: true,
  icon: true,
  id: true,
  invalid: true,
  label: true,
  placeholder: true,
  postfix: true,
  prefix: true,
  size: true,
  value: true
};
